module.exports = __webpack_public_path__ + "static/media/top1_on.df4bd9e3.png";